<div class="o-flex--full">
  <form class="o-flex o-flex--column u-margin-bottom-m" [formGroup]="form">
    <div class="o-flex o-flex--gap-1">
      <mat-form-field class="o-flex--full" floatLabel="always" appearance="outline">
        <mat-label>First name</mat-label>
        <input matInput formControlName="first_name" required/>
        <mat-error *ngIf="form.get('first_name')?.hasError('required')">
          First name is required
        </mat-error>
      </mat-form-field>
      <mat-form-field class="o-flex--full" appearance="outline">
        <mat-label>Last name</mat-label>
        <input matInput formControlName="last_name" required/>
        <mat-error *ngIf="form.get('last_name')?.hasError('required')">
          Last name is required
        </mat-error>
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline">
      <mat-label>Email address</mat-label>
      <input matInput formControlName="email" required/>
      <mat-error *ngIf="form.get('email')?.hasError('required')">
        Email is required
      </mat-error>
      <mat-error *ngIf="form.get('email')?.hasError('email_exists')">
        A user with this email already exists
      </mat-error>
    </mat-form-field>
    <div class="consent-accepted-checkbox">
      <label>
        <mat-checkbox color="primary" formControlName="privacy_policy" name="privacy_policy" data-cons-preference="privacy_policy_conesnt"></mat-checkbox>
        <span class="privacy-terms-text">&nbsp;I have read and I accept the <a class="hyper-link-color" href="#" target="_blank" [routerLink]="['/privacy-policy']">Privacy Policy</a></span>
      </label>
    </div>
    <div class="consent-accepted-checkbox">
      <label>
        <mat-checkbox color="primary" formControlName="terms" name="terms" data-cons-preference="terms_conesnt"></mat-checkbox>
        <span class="privacy-terms-text">&nbsp;I have read and I accept the <a class="hyper-link-color" href="#" target="_blank" [routerLink]="['/terms']">Terms and Conditions</a></span>
      </label>
    </div>
  </form>
</div>
